@if (order) {
  <div class="card shadow-sm border-0 invoice-card" id="print-section">
    <div class="card-body p-4">
      <!-- 🔷 HEADER -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5 class="fw-bold mb-0 text-primary">
            {{ elementService.getCurrentElement()?.element_code }} -
            {{ order.order_number }}
          </h5>

          <div class="small text-muted">
            Date: {{ order.order_date | date: 'dd-MM-yyyy' }}
          </div>
        </div>
      </div>

      <hr class="invoice-divider" />

      <!-- 🔷 CONTACT + ADDRESS -->
      <div class="row mb-4">
        <!-- LEFT -->
        <div class="col-md-6">
          <div class="invoice-block mb-3">
            <div class="label">Contact</div>
            <div class="value cursor-pointer hover text-primary text-decoration-underline" (click)="routeData.viewContact(order.contact)">{{ order.contact?.name }}</div>
          </div>

          <div class="invoice-block">
            <div class="label">Account</div>
            <div class="value">
              {{
                orderService.getOrderAccountByID(order.account_id)
                  ?.account_name || 'N/A'
              }}
            </div>
          </div>
        </div>

        <!-- RIGHT -->
        <div class="col-md-6 text-md-end">
          <div class="label mb-1">Address</div>

          <div class="value">
            <app-address-view
              [address]="order.order_address"
            ></app-address-view>
          </div>
        </div>
      </div>

      <!-- 🔷 ITEMS -->
      <div class="table-responsive mb-3">
        <table class="table table-sm align-middle mb-0 invoice-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Product</th>
              <th class="text-end">Qty</th>
              <th class="text-end">Rate</th>
              <th class="text-end">Amount</th>
            </tr>
          </thead>

          <tbody>
            @for (itm of order.order_line_items; track itm; let i = $index) {
              <tr>
                <td>{{ i + 1 }}</td>

                <td>
                  <div class="fw-semibold">
                    {{ itm.product_id | productItem }}
                  </div>
                  <div class="small text-muted">
                    {{ itm.line_description }}
                  </div>
                </td>

                <td class="text-end">
                  {{ itm.line_quantity | number: '1.2-2' }}
                </td>

                <td class="text-end">
                  {{ itm.line_price | currency: 'INR' }}
                </td>

                <td class="text-end fw-semibold text-primary">
                  {{ itm.line_amount | currency: 'INR' }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <!-- 🔷 SUMMARY -->
      <div class="d-flex justify-content-end">
        <div class="invoice-summary">
          <div class="d-flex justify-content-between mb-1">
            <span class="text-muted">Subtotal</span>
            <span>{{ order.order_subtotal | currency: 'INR' }}</span>
          </div>

          @if (order.order_discount_amount) {
            <div class="d-flex justify-content-between mb-1 text-danger">
              <span>Discount</span>
              <span>- {{ order.order_discount_amount | currency: 'INR' }}</span>
            </div>
          }

          @if (order.order_adjustment_amount) {
            <div class="d-flex justify-content-between mb-1">
              <span class="text-muted">Adjustment</span>
              <span>{{ order.order_adjustment_amount | currency: 'INR' }}</span>
            </div>
          }

          <hr />

          <!-- 🔥 GRAND TOTAL -->
          <div
            class="d-flex justify-content-between align-items-center total-row"
          >
            <span>Total</span>

            <span class="total-amount"> ₹ {{ order.order_total }} </span>
          </div>
        </div>
      </div>
    </div>
  </div>
}
